<template>
  <div class="app">
    <header class="header" v-if="isShowView">
      {{ headerTitle }}
    </header>
    <header class="header" v-if="isShowCheckHeader">
      {{ _("补丁校验") }}
    </header>
    <router-view
      @showView="showView"
      @showCheckHeader="showCheckHeader"
    ></router-view>
  </div>
</template>

<script>
export default {
  data() {
    return {
      headerTitle: this._("补丁更新"),
      isShowView: false,
      isShowCheckHeader: false,
    };
  },
  methods: {
    showView(title) {
      if (title) {
        this.headerTitle = title
      } else {
        this.headerTitle = this._("补丁更新");
      }
      this.isShowView = true;
    },
    showCheckHeader() {
      this.isShowCheckHeader = true;
    },
  },
};
</script>

<style scoped>
.header {
  height: 57px;
  background: #333237;
  color: #fff;
  font-size: 15px;
  text-align: center;
  line-height: 57px;
}
.app {
  padding-bottom: 44px;
}
</style>
